import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import metaLogo from '../../../assets/svg/hive-meta-logo.svg';
import tiktokLogo from '../../../assets/svg/hive-tiktok-logo.svg';
import googleLogo from '../../../assets/svg/hive-google-logo.svg';
import appMockup from '../../../assets/images/hive-app-mockup.png';
import './HiveHero.css';

const HiveHero = () => {
  const headingAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(-50px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 150, friction: 25 },
  });

  const contentAnimation = useSpring({
    from: { opacity: 0, transform: 'translateY(40px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 150, friction: 25 },
    delay: 200,
  });

  return (
    <div className="hive-hero">
      <animated.div style={headingAnimation} className="hive-hero-intro">
        <h1 className="hive-hero-heading">The EDC Hive SME Growth Engine</h1>
        <p className="hive-hero-subheading">
          Modern buying starts and ends with video. Turning TikTok and Instagram
          Reels into business growth.
        </p>
      </animated.div>

      <animated.div style={contentAnimation} className="hive-hero-body">
        <div className="hive-hero-copy">
          <h2 className="hive-hero-copy-title">
            The Problem: SME Creative bottleneck, needing Creator Video Without
            the Big-Brand Budget.
          </h2>
          <p>
            Your customers live on TikTok and Meta, and they only trust authentic,
            creator-led video. The problem is, influencer marketing has always been
            locked behind an enterprise price tag. Between bloated agency retainers
            and high creator fees, it&apos;s an expensive algorithmic gamble, if the
            post flops, your money is gone.
          </p>
          <p>
            This leaves growing SMEs completely priced out of the internet&apos;s most
            powerful attention &amp; growth engine, stuck running outdated ads that
            get instantly skipped.
          </p>

          <h2 className="hive-hero-copy-title hive-hero-copy-title-spaced">
            The Solution: Unlocking Short-Form Video Growth for Growing
            Businesses
          </h2>
          <p>
            EDC Hive completely flips the model. We take raw footage of your
            business—either shot by our team or supplied by you—and let our
            creators work their magic. They handle the editing, shape the hooks,
            and add their unique creative style to maximize engagement, providing
            you with high-performing content delivered on a pure CPV
            (Cost-Per-View) performance model.
          </p>
        </div>

        <div className="hive-hero-visual">
          <div className="hive-hero-logos" aria-label="Partner platforms">
            <img
              src={metaLogo}
              alt="Meta"
              className="hive-hero-logo hive-hero-logo-meta"
            />
            <img
              src={tiktokLogo}
              alt="TikTok"
              className="hive-hero-logo hive-hero-logo-tiktok"
            />
            <img
              src={googleLogo}
              alt="Google"
              className="hive-hero-logo hive-hero-logo-google"
            />
          </div>
          <img
            src={appMockup}
            alt="EDC Hive creator app"
            className="hive-hero-mockup"
          />
        </div>
      </animated.div>
    </div>
  );
};

export default HiveHero;
